import React, { useEffect, useState } from 'react';
import { Cookie } from 'lucide-react';

const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('magic_cookies');
    if (!accepted) setTimeout(() => setShow(true), 300);
  }, []);

  const decide = (val) => {
    localStorage.setItem('magic_cookies', val);
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 z-[55] bg-white shadow-2xl border-t border-gray-200 animate-in">
      <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="w-6 h-6 text-brand-red shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-brand-navy">Utilizziamo i cookie</h4>
            <p className="text-sm text-gray-600 mt-1 max-w-3xl">
              Questo sito utilizza cookie tecnici necessari per il funzionamento e cookie di terze parti per analisi e marketing. Puoi accettare tutti i cookie, personalizzare le tue preferenze o rifiutare quelli non necessari.{' '}
              <a href="#" className="text-brand-red font-semibold hover:underline">Leggi la nostra Cookie Policy</a>
            </p>
          </div>
        </div>
        <div className="flex gap-2 flex-wrap">
          <button onClick={() => decide('custom')} className="px-4 py-2 border border-gray-300 hover:border-brand-navy text-sm font-semibold rounded-md transition-colors">
            Personalizza
          </button>
          <button onClick={() => decide('rejected')} className="px-4 py-2 border border-gray-300 hover:border-brand-navy text-sm font-semibold rounded-md transition-colors">
            Rifiuta
          </button>
          <button onClick={() => decide('accepted')} className="px-5 py-2 bg-brand-navy hover:bg-brand-navy-light text-white text-sm font-bold rounded-md transition-colors">
            ✓ Accetta tutti
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
